import { sectionNav } from '@/mocks/mikami/sections';

const heroStats = [
  { value: '8', label: '内容分区' },
  { value: '6', label: '主题方向' },
  { value: '持续', label: '整理更新' },
];

export default function Hero() {
  return (
    <section id="top" className="relative flex min-h-[560px] w-full items-center overflow-hidden md:min-h-[680px]">
      <div className="absolute inset-0 h-full w-full">
        <img
          src="https://readdy.ai/api/search-image?query=Abstract%20cinematic%20background%20with%20deep%20warm%20rose%20and%20amber%20gradient%2C%20soft%20bokeh%20light%20spots%2C%20subtle%20film%20grain%20texture%2C%20elegant%20moody%20atmosphere%2C%20stylized%20artistic%20composition%2C%20dark%20tones%20suitable%20for%20white%20text%20overlay%2C%20high%20detail&width=1920&height=1080&seq=mikami-hero-bg&orientation=landscape"
          alt=""
          className="h-full w-full object-cover object-top"
        />
      </div>
      <div className="absolute inset-0 bg-gradient-to-b from-foreground-950/70 via-foreground-950/60 to-foreground-950/80"></div>

      <div className="relative z-10 w-full px-4 py-28 md:px-8 md:py-32">
        <div className="max-w-3xl">
          <span className="inline-flex items-center gap-2 rounded-full border border-background-50/30 bg-background-50/10 px-3 py-1 text-xs font-label text-background-100 md:text-sm">
            <i className="ri-sparkling-2-line text-accent-300"></i>
            资讯整理页 · 新片 / 消息 / 写真 / 活动 / 近况
          </span>

          <h1 className="mt-5 font-heading text-3xl font-bold leading-tight text-background-50 md:text-5xl">
            三上悠亚电影
            <span className="mt-2 block text-xl font-semibold text-accent-300 md:text-2xl">新片、最新动态与近况的整理汇总</span>
          </h1>

          <p className="mt-5 max-w-2xl text-sm leading-relaxed text-background-100 md:text-base">
            这里把分散的信息集中到一个页面：先看近期公开的新片方向，再顺着消息、写真、活动与近况逐条核对。条目按题材与类型分类，便于按需求快速定位，不必在多个来源之间来回切换。
          </p>

          <div className="mt-8 flex flex-col gap-3 sm:flex-row sm:flex-wrap">
            <a
              href="#films"
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md bg-primary-500 px-5 py-3 text-sm font-label text-background-50 transition-colors hover:bg-primary-600"
            >
              <i className="ri-film-line"></i>
              浏览新片速览
            </a>
            <a
              href="#recent"
              className="inline-flex cursor-pointer items-center justify-center gap-2 whitespace-nowrap rounded-md border border-background-50/40 px-5 py-3 text-sm font-label text-background-50 transition-colors hover:bg-background-50/15"
            >
              <i className="ri-time-line"></i>
              查看最新近况
            </a>
          </div>

          <div className="mt-8 flex flex-wrap gap-2">
            {sectionNav.map((item) => (
              <a
                key={item.id}
                href={`#${item.id}`}
                className="cursor-pointer whitespace-nowrap rounded-full border border-background-50/25 px-3 py-1.5 text-xs font-label text-background-100 transition-colors hover:border-accent-300 hover:text-accent-300 md:text-sm"
              >
                {item.label}
              </a>
            ))}
          </div>

          <dl className="mt-10 grid max-w-xl grid-cols-3 gap-4 border-t border-background-50/20 pt-6">
            {heroStats.map((stat) => (
              <div key={stat.label}>
                <dt className="font-heading text-2xl font-bold text-accent-300 md:text-3xl">{stat.value}</dt>
                <dd className="mt-1 text-xs text-background-100 md:text-sm">{stat.label}</dd>
              </div>
            ))}
          </dl>
        </div>
      </div>
    </section>
  );
}